<template>
  <dialogPanel
      ref="refDialog"
      :dialogState="fdialogState"
      @event-dialog-close="eventDialogClose"
      title="信息发布"
      wth="800"
      hth="504">
    <div class="que-header">
      <label>题目名称：</label><input v-model="queInfo.que_name"/>
      <label>标签：</label><input v-model="queInfo.que_tags"/>
      <label>难度：</label>
      <select v-model="queInfo.difficulty">
        <option value=0>入门</option>
        <option value=10>简单</option>
        <option value=20>中等</option>
        <option value=30>困难</option>
      </select>
      <label>官方解题：</label>
      <select v-model="queInfo.contain_answer">
        <option value="true">true</option>
        <option value="false">false</option>
      </select>
    </div>
    <markdownEditor
        ref="refMarkdown"
        mavon-class="mavon-360"></markdownEditor>
    <div class="que-footer">
      <span @click="releaseClick">发布</span>
    </div>
  </dialogPanel>
</template>

<script>
import dialogPanel from "@/components/panel/dialogPanel";
import markdownEditor from "@/components/common/markdownEditor";
import utils from "@/utils/utils";
import serviceApi from "@/utils/serviceApi";
export default {
  name: "queDialog",
  data(){
    return{
      queInfo: {
          gid:'',
          que_name:'',
          que_tags:'',
          que_context:'',
          difficulty: 20,
          contain_answer:'',
      }
    }
  },
  props:{
    dialogState:{
      type: Boolean,
      default: false
    }
  },
  watch:{
    "dialogState":{
      handler(newVal, oldVal) {
        if(newVal && !oldVal){
          serviceApi.loadQue(
              (resultData)=>{
                  this.queInfo = resultData;
                  //this.setContext(decodeURI(this.queInfo.que_context));
                  this.setContext(decodeURIComponent(this.queInfo.que_context));
                })
        }
      },
      deep: false,
      immediate: true
    }
  },
  computed:{
    fdialogState:function (){
      return this.dialogState
    }
  },
  methods:{
    eventDialogClose:function (){
      this.$emit("event-dialog-close")
    },
    setContext(value){
      this.$refs.refMarkdown.setContext(value)
    },
    releaseClick: function (){
      let htmlStr = this.$refs.refMarkdown.getContent();
      if (htmlStr == 'undefined' || htmlStr == undefined || htmlStr == ''){
        return
      }
      let flag = false
      if(this.queInfo.gid == null || this.queInfo.gid == ""){
        flag = true;
        this.queInfo.gid = utils.GetQueryString("gid")
      }
      //this.queInfo.que_context = encodeURI(htmlStr)
      this.queInfo.que_context = encodeURIComponent(htmlStr);

      serviceApi.updateQue(this.queInfo,()=>{
        this.$refs.refDialog.dialogClose();
        if(flag){
          location.reload();
          //window.open(window.location, "_self");
          //window.open("./index.html?gid=" + this.queInfo.gid, "_self");
        }else{
          location.reload();
        }
      })
    }
  },
  components:{
    dialogPanel,
    markdownEditor
  }
}
</script>

<style scoped>
.que-header{
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eee;
}
.que-header input{
  width: 150px;
  margin-right: 5px;
}
.que-header select{
  width: 80px;
  margin-right: 5px;
}
.que-footer{
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #eee;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.que-footer span{
  display: block;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  float: right;
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  margin-right: 20px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  color: #2e7eee;
}
.que-footer span:hover{
  background-color: #2e7eee;
  color: #fff;
}
</style>
